import ScheduleMeetingsBody from "components/ScheduleMeetings/ScheduleMeetingsBody";

const ScheduleMeeting = () => {
  return <ScheduleMeetingsBody />;
};

export default ScheduleMeeting;
